import { Helmet } from 'react-helmet-async';

export const SEO = ({ 
  title, 
  description, 
  keywords,
  canonical,
  ogType = 'website',
  noindex = false
}) => {
  const fullCanonical = canonical || `https://nhm-plomberie.fr${window.location.pathname}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      <link rel="canonical" href={fullCanonical} />
      
      <meta name="geo.region" content="FR-75" />
      <meta name="geo.placename" content="Paris 17e" />
      <meta name="geo.position" content="48.8850;2.3200" />
      <meta name="ICBM" content="48.8850, 2.3200" />
      
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:locale" content="fr_FR" />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullCanonical} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};
